'use-strict'
import React, {Fragment, useState, useEffect} from "react";
import Breadcrumb from "../common/breadcrumb/breadcrumb";
import {SessionCard} from "../common/sessionCard/SessionCard";
import {Search} from "react-feather";
import search from "../../assets/images/search-not-found.png";
import {
  Container,
  Row,
  Col,
  Card,
  CardHeader,
  CardBody,
  Label,
  Input,
  Button,
  Collapse,
  Spinner
} from "reactstrap";


import sessions from "./sessionsutils";

import DatePicker from "react-datepicker";
import sessionUtils from "./sessionsutils";
import {sessionManageUtils} from "../common/session/manage/sessionManage.utils"
import {toast} from "react-toastify";

import {
  HasRole,
} from 'react-role-permission';
import AppLink from "../common/AppLink";

const SessionList = (props) => {

  const [isFilter, setIsFilter] = useState(true);
  const [isFilter2, setIsFilter2] = useState(false);
  const [listasessioni, setListaSessioni] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const [odg, setOdg] = useState();
  const [oratore, setOratore] = useState();
  const [numseduta, setNumSeduta] = useState();
  const [searchtext, setSearchtext] = useState();
  const [datada, setDataDa] = useState(null);//(new Date(new Date().getTime() - (1000 * 60 * 60 * 24)));
  const [dataa, setDataA] = useState(null);//(new Date(new Date().getTime() + (1000 * 60 * 60 * 24)));

  // queryElasticSearch

  async function loadElasticSearchSession(isLast10) {
    setIsLoading(true);
    const typeTagsSearch = [];

    if ((oratore && oratore != '')) {
      typeTagsSearch.push({
        type: 'ORATORE',
        tags: [oratore]
      });
    }
    if ((odg && odg != '')) {
      typeTagsSearch.push({
        type: 'ODG',
        tags: [odg]
      });
    }
    if ((numseduta && numseduta != '')) {
      typeTagsSearch.push({
        type: 'NUMEROSESSIONE',
        tags: [numseduta]
      });
    }
    if ((document.getElementById('fasedellasedutaselect').value !== '')) {
      typeTagsSearch.push({
        type: 'FASESEDUTA',
        tags: [document.getElementById('fasedellasedutaselect').value]
      });
    }
    const queryobject = sessionManageUtils.searchSessionParamsTypeTags({
      groupId: localStorage.getItem('grp'),
      ownerId: localStorage.getItem('id'),
      roleType: localStorage.getItem('rl') == 'user' ? 'GROUP_USER' : localStorage.getItem('rl').toUpperCase(),
      typeTags: typeTagsSearch,
      fromDate: datada ? datada : null,
      toDate: isLast10 ? new Date() : dataa ? dataa : null,
      toString: true,
      term: searchtext,
      size: isLast10 ? 10 : null,
      direction: "DESC",
      sortProperties: ['date', 'videoItem.id']
    });


    console.log('----------');
    console.log(queryobject);
    try {
      const search = await sessionUtils.methods.queryElasticSearch(queryobject);
      const searchResponse = search.payload;
      console.log('SEARCH: ', searchResponse);
      const resultlist = [];
      if (searchResponse.length > 0) {
        for (var i = 0; i < searchResponse.length; i++) {
          /**
           * "videoItem": {
        "id": 0,
        "name": "string",
        "description": "string",
        "transcriptionURL": "string",
        "videoURL": "string",
        "pvtURL": "string",
        "thumbnailURL": "string",
        "refD": "2021-11-06T09:11:18.588Z",
        "date": "2021-11-06T09:11:18.588Z",
        "tags": [
          "string"
        ],
        "typeTags": [
          {
            "type": "string",
            "tags": [
              "string"
            ]
          }
        ],
        "privacy": "PUBLIC",
        "applicationId": "string",
        "groupId": "string",
        "ownerId": "string",
        "referenceDate": "string"
      }
           */
          var id = -1;
          var numsessione = -1;
          for (var z = 0; z < searchResponse[i].videoItem.typeTags.length; z++) {
            if (searchResponse[i].videoItem.typeTags[z]?.type === 'ID')
              id = searchResponse[i].videoItem.typeTags[z].tags[0];
            if (searchResponse[i].videoItem.typeTags[z]?.type === 'NUMEROSESSIONE')
              numsessione = searchResponse[i].videoItem.typeTags[z].tags[0];
          }

          const record = {
            deleted: false,
            description: searchResponse[i].videoItem.description,
            id: id,
            idGroup: searchResponse[i].videoItem.groupId,
            idStato: 1,
            linkTrascrizione: searchResponse[i].videoItem.transcriptionURL,
            linkVideo: searchResponse[i].videoItem.videoURL,
            name: searchResponse[i].videoItem.name,
            numeroSessione: numsessione,
            timenote: searchResponse[i].videoItem.timenote,
            timestamp: new Date(searchResponse[i].date),
            isPublic: searchResponse[i].videoItem.privacy === 'PUBLIC'
          }

          resultlist.push(record);
        }
      }

      console.log('RESULT: ', resultlist);

      setListaSessioni(resultlist);
      setIsLoading(false);
      window.scrollTo(0, 0);
      return resultlist;

    } catch (e) {
      setIsLoading(false);
      toast.error('Qualcosa è andato storto');
    }
  }


  const loadSessioniDb = async () => {
    try {
      const listasessioniraw = await sessions.methods.loadSessioni();
      let listasessionitmp = listasessioniraw.sort(function (a, b) {
        // Turn your strings into dates, and then subtract them
        // to get a value that is either negative, positive, or zero.
        return new Date(b.timestamp) - new Date(a.timestamp);
      })
      console.log(listasessionitmp);
      if (listasessionitmp) {
        if (Array.isArray(listasessionitmp) && listasessionitmp.length > 0)
          setListaSessioni(listasessionitmp);
        else
          setListaSessioni([]);
      } else {
        setListaSessioni([]);
        toast.error(
          "Qualcosa è andato storto..."
        );
      }
    } catch (err) {
      toast.error(
        "Qualcosa è andato storto..."
      );
    }
  }

  const loadSessioni = async () => {
    //loadSessioniDb();
    loadElasticSearchSession();
  }

  const loadPage = () => {
    //  loadSessioni();
  }


  useEffect(() => {
    loadElasticSearchSession(true);
  }, []);


  return (
    <Fragment>
      <Breadcrumb parent="Ricerca" title="Sessioni" subtitle="Ricerca"/>
      <Container fluid={true} onLoad={loadPage.bind(this)}>
        <Row>

          <Col xl="3 xl-40">
            <div
              className="default-according style-1 faq-accordion job-accordion"
              id="accordionoc"
            >
              <Row>


                <Col xl="12">
                  {HasRole('admin') || HasRole('group_admin') ? (
                    <AppLink to="/sessions/add"><Button color="danger" className="text-center">
                      Crea Nuova Sessione
                    </Button></AppLink>
                  ) : ''}
                  <br/> <br/>
                  <Card style={{overflow: "visible  "}}>
                    <CardHeader>
                      <h5 className="mb-0">
                        <Button
                          color="link pl-0"
                          data-toggle="collapse"
                          onClick={() => setIsFilter(!isFilter)}
                          data-target="#collapseicon"
                          aria-expanded={isFilter}
                          aria-controls="collapseicon"
                        >
                          Filtri Sessione
                        </Button>
                      </h5>
                    </CardHeader>
                    <Collapse isOpen={isFilter}>
                      <CardBody className="filter-cards-view animate-chk" style={{overflow: "visible  "}}>
                        <div className="job-filter">
                          <div className="faq-form">
                            <Input
                              className="form-control"
                              type="text"
                              placeholder="Cerca sessione..."
                              value={searchtext}
                              onChange={(e) => {
                                setSearchtext(e.target.value)
                              }}
                              onKeyPress={event => {
                                if (event.key === 'Enter') {
                                  loadSessioni();
                                }
                              }}
                            />
                            <Search className="search-icon"/>
                          </div>
                        </div>
                        <div className="job-filter" style={{overflow: "visible  "}}>
                          <div className="date-picker" style={{overflow: "visible  "}}>
                            <Label>Data da</Label>
                            {/* <DatePicker
                          className="form-control"
                          showPopperArrow={false}

                          dateFormat="dd/MM/yyyy"
                          value={datada}

                          /> */}
                            <DatePicker
                              className="form-control digits"
                              id='input_datada_sessione'
                              selected={datada}
                              onChange={(e) => {
                                setDataDa(e)
                              }}
                              dateFormat="dd/MM/yyyy"
                            />
                            {/* <MapPin className="search-icon" /> */}
                          </div>
                        </div>
                        <br/>
                        <div className="job-filter">
                          <div className="date-picker">
                            <Label>Data a</Label>
                            <DatePicker
                              className="form-control digits"
                              id='input_dataa_sessione'
                              selected={dataa}
                              onChange={(e) => {
                                setDataA(e)
                              }}
                              dateFormat="dd/MM/yyyy"
                            />
                            {/* <MapPin className="search-icon" /> */}
                          </div>
                        </div>
                        <br/>


                      </CardBody>
                    </Collapse>
                  </Card>
                </Col>

                <Col xl="12">
                  <Card>
                    <CardHeader>
                      <h5 className="mb-0">
                        <Button
                          color="link pl-0"
                          data-toggle="collapse"
                          onClick={() => setIsFilter2(!isFilter2)}
                          data-target="#collapseicon"
                          aria-expanded={isFilter2}
                          aria-controls="collapseicon"
                        >
                          Filtri Avanzati
                        </Button>
                      </h5>
                    </CardHeader>
                    <Collapse isOpen={isFilter2}>
                      <CardBody className="filter-cards-view animate-chk">
                        <div className="job-filter">
                          <Label>Oratore</Label>
                          {/* <div className="faq-form"> */}

                          <Input
                            className="form-control"
                            type="text"
                            placeholder=""
                            value={oratore}
                            onChange={(e) => {
                              setOratore(e.target.value)
                            }}
                            onKeyPress={event => {
                              if (event.key === 'Enter') {
                                loadSessioni();
                              }
                            }}
                          />
                          {/* <Search className="search-icon" /> */}
                          {/* </div> */}
                        </div>
                        <div className="job-filter">
                          <Label>Numero Seduta</Label>
                          {/* <div className="faq-form"> */}

                          <Input
                            className="form-control"
                            type="text"
                            placeholder=""
                            value={numseduta}
                            onChange={(e) => {
                              setNumSeduta(e.target.value)
                            }}
                            onKeyPress={event => {
                              if (event.key === 'Enter') {
                                loadSessioni();
                              }
                            }}
                          />
                          {/* <Search className="search-icon" /> */}
                          {/* </div> */}
                        </div>
                        <div className="job-filter">
                          <Label>Fase della Seduta</Label>
                          {/* <div className="faq-form"> */}
                          {/*
                      <Typeahead
                            id="basic-typeahead-example"
                            labelKey="name"
                            className="btn-pill"
                            //multiple
                            onChange= {(e) => {setGruppo(e)}}
                            options={["Gruppo1", "Gruppo2", "Gruppo3"]}//TODO
                            placeholder="Scegli gruppo..."
                            selected={gruppo} />*/}

                          <select id="fasedellasedutaselect" className="form-control btn-pill" size="1">
                            <option value=''>Seleziona</option>
                            <option value="nessuna">Nessuna</option>
                            <option value="annunci">Annunci</option>
                            <option value="sospensioni">Sospensioni</option>
                          </select>
                          {/* <Search className="search-icon" /> */}
                          {/* </div> */}
                        </div>
                        <br/>
                        <div className="job-filter">
                          <Label>ODG</Label>
                          {/* <div className="faq-form"> */}

                          <Input
                            className="form-control"
                            type="text"
                            placeholder=""
                            value={odg}
                            onChange={(e) => {
                              setOdg(e.target.value)
                            }}
                            onKeyPress={event => {
                              if (event.key === 'Enter') {
                                loadSessioni();
                              }
                            }}
                          />
                          {/* <Search className="search-icon" /> */}
                          {/* </div> */}
                        </div>
                        <br/>

                      </CardBody>
                    </Collapse>
                  </Card>
                  <Button color="primary" className="text-center" onClick={loadSessioni}>
                    Cerca
                  </Button>
                </Col>
              </Row>
            </div>
          </Col>


          <Col xl="9 xl-60">
            <Row>

              {
                !isLoading ?
                  (Array.isArray(listasessioni) && listasessioni.length == 0) ?

                    (
                      <Col xl="12 xl-100" key={'norows'}>
                        <Card
                          className={''}
                        >
                          <div className="job-search">
                            <CardBody>
                              <div className="search-not-found text-center" style={{maxHeight: '15vh'}}>
                                <div>
                                  <img src={search} alt="" className="second-search"/>
                                  <p className="mb-0">
                                    Non ci sono risultati per i criteri selezionati
                                  </p>
                                </div>
                              </div>
                            </CardBody>
                          </div>
                        </Card>
                      </Col>
                    )
                    :
                    listasessioni.map((data, i) => {
                      return (
                        <SessionCard card={data} showStatus={true} key={data.id}/>
                      );
                    })
                  :
                  (
                    <Col xl="12 xl-100" key={'norows'}>
                      <Card
                        className={''}
                      >
                        <div className="job-search">
                          <CardBody>
                            <div className="search-not-found text-center" style={{maxHeight: '15vh'}}>

                              <Spinner/>
                            </div>
                          </CardBody>
                        </div>
                      </Card>
                    </Col>
                  )
              }
            </Row>
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};

export default SessionList;
